export const environment = {
  production: true,
  apiBase: 'https://rest.bhavani.app',
  assetsBase: '',
  assets: {
    logo: 'assets/images/logo.png',
    logo_alternative:'assets/images/logo_alternative_1.png'
  },
  favico:"favicon.ico",
  company: "Bhavani",
  emails:{
   contact_email:"hi@bhavani.app",
   support_email:"sistemas@bhavani.app"
  },
  links:{
    landing_base_link:'bhavani.app/',
    platform_base_link:'my.bhavani.app/',
    learning_base_link:null
  },
  wsBase: 'wss://rest.bhavani.app',
  calendlyUrl: 'https://calendly.com/bhavaniwellness/30min',
  tinyMceEditorApiKey: 'asuikioz2gy5mjd86a42dq46fv8cghkwhaf6tlp7yu0lktg6'
};